import { useTranslation } from 'react-i18next'
import { Radio } from 'antd'
import { IProfile } from 'interfaces/users'
import { AccessLevelEnum } from 'enum/accessLevel'
import { Subtitle, Option, OptionTitle, OptionDescription } from './styled'
import SelectProfiles from './selectProfiles'

interface IProps {
  profiles: IProfile[]
  loading: boolean
  selectedProfiles: IProfile[]
  setSelectedProfiles: (profiles: IProfile[]) => void
  accessLevel: AccessLevelEnum
  setAccessLevel: (accessLevel: AccessLevelEnum) => void
}

const SelectAccessLevel = ({
  profiles,
  loading,
  selectedProfiles,
  setSelectedProfiles,
  accessLevel,
  setAccessLevel,
}: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.assignRole.inputs.chooseAccessLevel'

  return (
    <>
      <Subtitle>{t(`${prefix}.title`)}</Subtitle>
      <Option
        active={accessLevel === AccessLevelEnum.AllCollaborators}
        onClick={() => setAccessLevel(AccessLevelEnum.AllCollaborators)}
      >
        <Radio checked={accessLevel === AccessLevelEnum.AllCollaborators} />
        <OptionTitle>
          {t(`${prefix}.options.allCollaborators.title`)}
        </OptionTitle>
        <OptionDescription>
          {t(`${prefix}.options.allCollaborators.description`)}
        </OptionDescription>
      </Option>
      <Option
        active={
          accessLevel === AccessLevelEnum.DirectTeamAndSpecificCollaborators
        }
        onClick={() =>
          setAccessLevel(AccessLevelEnum.DirectTeamAndSpecificCollaborators)
        }
      >
        <Radio
          checked={
            accessLevel === AccessLevelEnum.DirectTeamAndSpecificCollaborators
          }
        />
        <OptionTitle>
          {t(`${prefix}.options.directTeamAndSpecificCollaborators.title`)}
        </OptionTitle>
        <OptionDescription>
          {t(
            `${prefix}.options.directTeamAndSpecificCollaborators.description`
          )}
        </OptionDescription>
      </Option>
      {accessLevel === AccessLevelEnum.DirectTeamAndSpecificCollaborators && (
        <SelectProfiles
          profiles={profiles}
          loading={loading}
          selectedProfiles={selectedProfiles}
          setSelectedProfiles={setSelectedProfiles}
        />
      )}
      <Option
        active={accessLevel === AccessLevelEnum.SpecificCollaborators}
        onClick={() => setAccessLevel(AccessLevelEnum.SpecificCollaborators)}
      >
        <Radio
          checked={accessLevel === AccessLevelEnum.SpecificCollaborators}
        />
        <OptionTitle>
          {t(`${prefix}.options.specificCollaborators.title`)}
        </OptionTitle>
        <OptionDescription>
          {t(`${prefix}.options.specificCollaborators.description`)}
        </OptionDescription>
      </Option>
      {accessLevel === AccessLevelEnum.SpecificCollaborators && (
        <SelectProfiles
          profiles={profiles}
          loading={loading}
          selectedProfiles={selectedProfiles}
          setSelectedProfiles={setSelectedProfiles}
        />
      )}
      <Option
        active={accessLevel === AccessLevelEnum.DirectTeam}
        onClick={() => setAccessLevel(AccessLevelEnum.DirectTeam)}
      >
        <Radio checked={accessLevel === AccessLevelEnum.DirectTeam} />
        <OptionTitle>{t(`${prefix}.options.directTeam.title`)}</OptionTitle>
        <OptionDescription>
          {t(`${prefix}.options.directTeam.description`)}
        </OptionDescription>
      </Option>
    </>
  )
}

export default SelectAccessLevel
